let config = {
    title: 'Cursed Energy: Overload',
    email: 'bethannfidel8629@gmail.com',
    policy: 'https://kaisenbinding.com/privacy_policy.html',
    term: 'https://kaisenbinding.com/terms.html', 
    copyright: '© 2026 Kauai Rooster Games',
    introduceTitle: [
       `Step into a world where ancient legends collide with modern-day threats! Are you ready to dive back into the thrilling tactical action of a sorcerous realm, a world teeming with malevolent spectral entities and powerful arcane practitioners? Remember the rush of mastering complex abilities and facing off against forces beyond human comprehension? This is your chance to relive and redefine that excitement!`
    ],
    introduceText: [
        {
            title: '• DEVASTATING ARCANE COMBAT',
            text: [
                `Experience visceral, impact-heavy battles that demand strategic mastery. Combine elemental abilities and unleash explosive ultimate techniques to crush spectral foes and rival sorcerers. Every attack feels impactful, every victory earned.`
            ]
        },
        {
            title: '• ICONIC MENTORS & PRODIGIES',
            text: [
                'Collect and command a diverse roster of powerful arcane users, from seasoned veterans with unmatched strength to gifted young talents still mastering their inherent gifts. Forge bonds, unlock their full potential, and witness their unique abilities unfold on the battlefield.'
            ]
        },
        {
            title: '• UNRAVEL THE SHADOWED REALM',
            text: [
                'Journey through a world besieged by malevolent spectral beings. Immerse yourself in a thrilling narrative filled with ancient secrets, perilous missions, and unexpected alliances. Your choices will determine the fate of humanity against encroaching darkness.'
            ]
        },
        {
            title: '• STRATEGIC TEAM FORMATIONS',
            text: [
                `Build your ultimate squad, leveraging synergistic abilities and tactical positioning. Adapt your approach for different challenges, exploiting enemy weaknesses and maximizing your team's arcane output. Victory favors the cunning.`
            ]
        },
        {
            text: [
                'Recruit a diverse cast of characters, each possessing unique arcane talents and combat styles. Train them, evolve them, and unlock their hidden potential to assemble an unstoppable force capable of cleansing the world of its spectral blight. '
            ]
        }
    ]
}
export default config;